import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowRight,
  FaWhatsapp
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { name: 'Underground Cable Wiring', path: '/services' },
    { name: 'Electricity Meters', path: '/services' },
    { name: 'Road Construction', path: '/services' },
    { name: 'Road Building', path: '/services' },
    { name: 'Underground Works', path: '/services' }
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' },
    { name: 'Get Quote', path: '/contact' }
  ];

  return (
    <footer className="footer">
      <div className="indian-accent"></div>

      <div className="footer-main">
        <Container>
          <Row className="g-4">
            {/* Company Info */}
            <Col lg={4} md={6}>
              <div className="footer-widget">
                <h3 className="footer-widget-title">Infrastructure Company</h3>
                <p className="footer-text">
                  Leading infrastructure solutions provider in India, specializing in
                  road construction, underground cable wiring, and electrical installations
                  with over 15 years of excellence.
                </p>
                <div className="social-links">
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="Twitter"
                  >
                    <FaTwitter />
                  </a>
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                  <a
                    href="https://wa.me/919876543210"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="WhatsApp"
                  >
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </Col>

            {/* Services */}
            <Col lg={2} md={6}>
              <div className="footer-widget">
                <h3 className="footer-widget-title">Our Services</h3>
                <ul className="footer-links">
                  {services.map((service, index) => (
                    <li key={index}>
                      <Link to={service.path}>
                        <FaArrowRight className="link-icon" />
                        {service.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Quick Links */}
            <Col lg={2} md={6}>
              <div className="footer-widget">
                <h3 className="footer-widget-title">Quick Links</h3>
                <ul className="footer-links">
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <Link to={link.path}>
                        <FaArrowRight className="link-icon" />
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            {/* Contact Info */}
            <Col lg={4} md={6}>
              <div className="footer-widget">
                <h3 className="footer-widget-title">Contact Us</h3>
                <ul className="footer-contact">
                  <li>
                    <FaMapMarkerAlt className="contact-icon" />
                    <span>
                      123, Infrastructure Street
                      <br />
                      Mumbai, Maharashtra 400001
                    </span>
                  </li>
                  <li>
                    <FaPhone className="contact-icon" />
                    <a href="tel:+919876543210">+91 98765 43210</a>
                  </li>
                  <li>
                    <FaEnvelope className="contact-icon" />
                    <a href="mailto:info@yourcompany.com">info@yourcompany.com</a>
                  </li>
                </ul>
                <div className="footer-timing">
                  <p>
                    <strong>Working Hours:</strong>
                  </p>
                  <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom">
        <Container>
          <Row>
            <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
              <p className="mb-0">
                &copy; {currentYear} Infrastructure Company. All Rights Reserved.
              </p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <p className="mb-0">
                Designed & Developed with <span className="heart">❤</span> in India
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;